import { useEffect } from "react";

const SITE_NAME = "WiseCursor";
const SITE_ORIGIN = "https://www.wisecursor.com";

const upsertMeta = (attribute, key, content) => {
    let element = document.head.querySelector(`meta[${attribute}="${key}"]`);

    if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
    }

    element.setAttribute("content", content);
};

const Seo = ({ canonicalPath, description, noIndex = false, title }) => {
    useEffect(() => {
        const pageTitle = title === SITE_NAME ? title : `${title} | ${SITE_NAME}`;
        const canonicalUrl = `${SITE_ORIGIN}${canonicalPath}`;

        document.title = pageTitle;
        upsertMeta("name", "description", description);
        upsertMeta("name", "robots", noIndex ? "noindex, nofollow" : "index, follow");
        upsertMeta("property", "og:title", pageTitle);
        upsertMeta("property", "og:description", description);
        upsertMeta("property", "og:type", "website");
        upsertMeta("property", "og:url", canonicalUrl);
        // Avoid requesting a large social preview until a purpose-built branded
        // image exists at a stable public URL.
        upsertMeta("name", "twitter:card", "summary");
        upsertMeta("name", "twitter:title", pageTitle);
        upsertMeta("name", "twitter:description", description);

        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", canonicalUrl);
    }, [canonicalPath, description, noIndex, title]);

    return null;
};

export default Seo;
